// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_0-3";
export var dialog = "_0-0";
export var divClassnameSwatch = "_0-8";
export var flexSwatch = "_0-4";
export var header = "_0-1";
export var styleAttributeSwatch = "_0-7";
export var swatch = "_0-2";
export var textHeaderSwatch = "_0-5";
export var webSwatch = "_0-6";